const firstNonEmptyArray = (...values) =>
  values.find((value) => Array.isArray(value) && value.length > 0) || [];

export const buildEducationProjectLexicon = (
  formData,
  educationEntry,
  projectText,
) => ({
  skills: Array.isArray(formData?.skills) ? formData.skills : [],
  specializedExperience:
    formData?.experienceRequirements || formData?.specializedExperience || '',
  competencies: firstNonEmptyArray(
    formData?.softSkills,
    formData?.competencies,
  ),
  knowledge: formData?.requiredSkills || formData?.knowledge || [],
  keywords: firstNonEmptyArray(
    formData?.selectedJobKeywords,
    formData?.jobKeywords,
    formData?.keywords,
  ),
  series: formData?.series || '',
  education: {
    institution: educationEntry?.institution || '',
    degree: educationEntry?.degree || '',
    major: educationEntry?.major || '',
    significantProjects: [projectText],
  },
  courses: Array.isArray(educationEntry?.relevantCourses)
    ? educationEntry.relevantCourses
    : [],
});

export const getEducationProjectEnhancement = (data) => {
  let parsedData = data;

  if (typeof parsedData === 'string') {
    try {
      parsedData = JSON.parse(parsedData);
    } catch {
      return parsedData.trim();
    }
  }

  const enhancedResult = parsedData?.enhancedResults?.[0];
  const candidates = [
    enhancedResult?.enhancement,
    enhancedResult?.enhancedProject,
    parsedData?.enhancedProject,
    parsedData?.project,
    parsedData?.enhancement,
    parsedData?.result,
    parsedData?.content,
    parsedData?.choices?.[0]?.message?.content,
  ];

  return (
    candidates
      .find(
        (candidate) =>
          typeof candidate === 'string' && candidate.trim(),
      )
      ?.trim() || ''
  );
};

export const enhanceEducationProject = async ({
  axiosClient,
  baseUrl,
  formData,
  educationEntry,
  projectText,
}) => {
  const sourceText = projectText?.trim();
  if (!sourceText) {
    throw new Error('Enter a project description before enhancing it.');
  }

  const response = await axiosClient.post(
    `${baseUrl}/api/jobSeriesSearchHttp`,
    {
      prompt: 'enhanceWorkHistory',
      resumeLexicon: buildEducationProjectLexicon(
        formData,
        educationEntry,
        sourceText,
      ),
      updateField: 'significantProjects',
      userID: formData?.user,
    },
    { headers: { 'Content-Type': 'application/json' } },
  );

  const enhancedText = getEducationProjectEnhancement(response.data);
  if (
    !enhancedText ||
    enhancedText.toLocaleLowerCase() === sourceText.toLocaleLowerCase()
  ) {
    throw new Error(
      'The AI did not return a revised project description. Please try again.',
    );
  }

  return enhancedText;
};
